(ns ycweb.app.pos.sell
  (:require
   [util.string :as str]
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.header :as header]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.components.transitions :as t]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [clojure.set :as set]
   [ycweb.app.pos.menu :as menu]))

(defn sell-comms [app-atom extra]
  (merge
    extra
    {:orderuuid (get-in @app-atom [:sell :orderuuid])}))

(defn send-delivery-details [app-atom]
  (let [delivery (get-in @app-atom [:sell :delivery])
        delivery-lookup (:lookup delivery)
        selected (:selected-address delivery)
        newslettersubscribed? (:newslettersubscribe delivery-lookup)
        promotionsubscribed? (:promotionsubscribe delivery-lookup)
        cleaned (dissoc delivery :lookup :addresslist :selected-address)
        unaltered
        (=
          (select-keys selected (keys cleaned))
          (select-keys cleaned (keys selected)))

        cleaned
        (assoc cleaned
          :addresschecked
          (if (and (= (:addresschecked cleaned) 1) unaltered) 1 0)
          :newslettersubscribe newslettersubscribed?
          :promotionsubscribe promotionsubscribed?)]

    (comms/send :pos/deliverydetails
      (sell-comms app-atom
        {:delivery cleaned}))))

(defn totals [app-atom]
  (rum/cursor-in app-atom [:sell :totals-atom]))

(defn cart [app-atom]
  (rum/cursor-in app-atom [:sell :cart]))

(defmethod grid/action :sell/start-cart [app-atom config _]
  (comms/send :pos/load-cart (sell-comms app-atom {:pos/target-screen :sell})))

(defmethod grid/action :sell/refresh-cart [app-atom config _]
  (toaster/open-toast app-atom :processing "Refreshing" {:closetime 10000})
  (comms/send :pos/load-cart (sell-comms app-atom {})))

(declare check-change)
(declare calc-totals)

(defmethod comms/receive :pos/load-cart [app-atom e]
  (toaster/close-toast app-atom)
  (when (:pos/success-message e)
    (toaster/open-toast app-atom :success (:pos/success-message e) {}))

  (swap! app-atom
    #(-> %
       (assoc
         :priceoverridereasons (:priceoverridereasons e)
         :totals-atom {}
         :payments {}
         :sell
         {:orderuuid (:orderuuid e)
          :cart
          {:resumedcart (:resumedcart e)
           :items (:items e)
           :payments
           (map
             (fn [p]
               (set/rename-keys p {:pmt_id :id}))
             (:payments e))}
          :delivery
          (if (u/presence (:email (:delivery e)))
            (assoc (:delivery e) :lookup (:delivery e))
            {:lookup {:invoice true :newslettersubscribe false :promotionsubscribe false}})})
       check-change))
  (rum/derived-atom
    [(rum/cursor-in app-atom [:sell :cart :items])
     (rum/cursor-in app-atom [:sell :cart :payments])
     (rum/cursor-in app-atom [:sell :delivery :method])
     (rum/cursor-in app-atom [:config :delivery])] ::totals

    (fn [items payments method delivery-config]
      ;; Just in case delivery-config has not loaded yet (which is sometimes the case for logout/login)
      (let [delivery-config (or delivery-config {:threshold 400 :fixed 60 :partnercollection 25 :vatrate 0.15})]
        (calc-totals items payments method delivery-config)))

    {:ref (rum/cursor-in app-atom [:sell :totals-atom])})

  (when (:pos/target-screen e)
    (t/transition-next app-atom (or (:pos/target-screen e) :sell))))

(rum/defc add-user-slat < rum/reactive [delivery-atom totals-atom click-fn]
  (let [state (rum/react delivery-atom)]
    [:div.slats
     (when (or (:email state) (pos? (cmn/curact totals-atom :item-count)))
       [:a.slat.user-slat
        (when click-fn
          {:on-click click-fn})
        [:div.user-slat__image-wrapper
         [:i {:class (u/bem :icon [:user :block])}]]
        [:div.user-slat__title.u-text-underline
         [:b (or (when (:firstname state) (str (:firstname state) " " (:lastname state)))
               (when-not (str/blank? (:email state)) (:email state))
               "Add Customer")]]
        (when click-fn
          [:div.user-slat__icon-wrapper
           [:i {:class (u/bem :icon [:arrow-right :block])}]])])]))

(declare finish-print)

(def sell-steps
  (forms/setup-steps
    [{:key :scan :title "Scan Products"}
     {:key :sell/scan-coin :title "Coin"}
     {:key :delivery/summary :title "Checkout"}
     {:key :delivery/customer :title "Add Customer"}
     {:key :delivery/company :title "Add Company"}
     {:key :delivery :title "Delivery Details"}
     {:key :delivery/cartnote :title "Order Notes"}
     {:key :payment :title "Payment"}
     {:key :finish :title "Finish"}]))

(def resumed-sell-steps
  (forms/setup-steps
    [{:key :scan :title "View Cart"}
     {:key :payment :title "Payment"}
     {:key :finish :title "Finish"}]))

; ========= Sell Screen Wrapper  ===========================
;; Let's not do this song and dance for every single sale screen
(defn cart-menu-modal [app-atom progress-step]
  (let [cart @(cart app-atom)]
    (grid/menu-modal app-atom
      {:items
       [(when (= progress-step :sell/scan-coin)
          {:label "Skip Coin Scan"
           :action :sell/checkout})
        (when-not (:resumedcart cart)
          {:label "Manual Barcode"
           :action :sell/open-barcode-modal})
        (when-not (:resumedcart cart)
          {:label "Manual Voucher"
           :action :sell/open-voucher-modal})
        {:label "Open Till"
         :action :sell/open-till-modal}
        {:label "Discard Sale"
         :action :sell/open-discard-confirm-modal
         :style
         {:full true :large true :negative true
          :icon-left :delete :text-default true :icon-class :3-2}}
        {:label "Cancel"
         :action :sell/cancel-cart-menu-modal
         :style
         {:full true :large true :text-link true :on-dark true}}]})))

(rum/defc sell-screen-wrapper < rum/reactive
  [app-atom progress-step body foot-note call-to-action]

  (let [sell-atom (rum/cursor app-atom :sell)
        menu-atom (rum/cursor app-atom :menu)]
    [:div.page-body
     (header/header app-atom "Sell"
       (when-not (:resumedcart @(cart app-atom))
         {:search-click #(swap! sell-atom assoc :search {:open true :input ""})}))
     (header/menu-overlay menu-atom)
     (header/menu app-atom (menu/select-menus app-atom))
     (header/search app-atom)

     (into
       [:div.page-body__main-content
        [:nav.section.button-bar

         (buttons/button
           "Sale Options" #(cart-menu-modal app-atom progress-step)
           {:icon-right :dots-menu-horizontal :muted true :text-default true})]

        [:div.section
         (forms/progress-steps
           (forms/progress-step
             (if (cmn/curact sell-atom [:cart :resumedcart])
               resumed-sell-steps
               sell-steps)
             progress-step))]]

       body)

     (into
       [:aside.page-body__footer]
       foot-note)
     call-to-action]))

;; ========= Main Cart Screen (items) ===========================
(defn collate-items [items]
  (->>
    (reduce
      (fn [acc i]
        (update acc
          [(:specialgroupnumber i) (or (:registryvariation_id i) (:variation_id i)) (:price i) (:delivery i)
           (when (= (:code i) "Voucher") (:barcode i))]
          (fnil #(-> %
                   (update :qty (fnil inc 0))
                   (update :ids conj (:cartitem_id i)))
            (dissoc i :qty))))
      {}
      items)
    vals
    (sort-by (comp u/dt-millis :dateadded))
    reverse))

(defn cartitem-menu-modal
  [app-atom item]
  (grid/menu-modal app-atom
    {:item item
     :items
     [{:label "Product Info"
       :action :sell/cartitem-menu-product}

      {:label "Adjust Qty"
       :action :sell/cartitem-menu-adjustqty}

      {:label "Adjust Price"
       :action :sell/cartitem-menu-adjustprice}

      {:label
       (if (= (:delivery item) "Delivery")
         "Take from shop"
         "Mark for delivery")
       :action :sell/cartitem-menu-toggledelivery}

      {:label "Remove Item"
       :action :sell/remove-item
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :sell/cartitem-menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defn render-itemslats [app-atom grouped-items ungrouped-items show-group? resumed-cart?]
  (let [render-items
        (fn [items]
          (map
            (partial cards/product-slat
              {:options-fn
               (when-not resumed-cart?
                 #(cartitem-menu-modal app-atom %))})
            items))]
    (cond
      (not show-group?)
      (render-items (concat grouped-items ungrouped-items))

      :else
      (concat
        (->>
          (group-by :specialgroupnumber grouped-items)
          (sort-by first)
          (mapcat
            (fn [[g items]]
              (concat
                [[:h3.slat.sub-heading-slat
                  [:span.sub-heading-slat__text (str "Special bundle " g ":")]]]
                (render-items items)))))
        (when (not-empty ungrouped-items)
          (into
            [[:h3.slat.sub-heading-slat
              [:span.sub-heading-slat__text "Other items "]]
             (render-items ungrouped-items)]))))))

(rum/defc render-cart < rum/reactive [app-atom]
  (let [cart-atom (cart app-atom)
        store (rum/cursor-in app-atom [:selected-warehouse])
        items (collate-items (cmn/curact cart-atom :items))
        [deliveritems shopitems] (u/separate #(= (:delivery %) "Delivery") items)
        [delivery-grouped delivery-ungrouped] (u/separate :specialgroupnumber deliveritems)
        [shop-grouped shop-ungrouped] (u/separate :specialgroupnumber shopitems)
        show-group? (or (not-empty delivery-grouped) (not-empty shop-grouped))
        shop-grouped (sort-by (juxt :specialgroupnumber :price) (comp - compare) shop-grouped)
        resumed-cart? (true? (:resumedcart @cart-atom))]

    (cond
      (not (empty? items))
      [:div
       (when (and (not (empty? shopitems)) (not (empty? deliveritems)))
         [:div.section])

       (when-not (empty? shopitems)
         (into
           [:div.slats.slats--items-to-take
            (when (and (not (empty? shopitems)) (not (empty? deliveritems)))
              [:h3.slat.heading-slat
               [:span.heading-slat__icon-wrapper
                [:i {:class (u/bem :icon [:block :shopping-bag])}]]
               [:span.heading-slat__text
                "From Yuppiechef " (or (cmn/curact store :displayname) "Store") ":"]])]
           (render-itemslats app-atom shop-grouped shop-ungrouped show-group? resumed-cart?)))

       (when-not (empty? deliveritems)
         (into
           [:div.slats.slats--items-to-deliver
            (when-not (empty? deliveritems)

              [:h3.slat.heading-slat
               [:span.heading-slat__icon-wrapper
                [:i {:class (u/bem :icon [:block :truck])}]]
               [:span.heading-slat__text
                "For Delivery:"]])]
           (render-itemslats app-atom delivery-grouped delivery-ungrouped show-group? resumed-cart?)))]

      :else
      [:div.section
       [:p]
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "Scan Products or Search"]
       [:div
        [:i.u-block-center
         {:class
          (u/bem
            :icon
            [:2-1 :barcode-scan :light-force :enormous :block])}]]])))

(defn movement-request [scan]
  (let [[request-type location-id location barcode :as movement-request] (str/split scan #":")]
    (when (and (= 4 (count movement-request)) (= "M" request-type))
      {:type request-type :location-id location-id :location location :barcode barcode})))

;; Add item
(defn add-cart-item [app-atom delivery? qty product]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/add-item
    (sell-comms app-atom
      {:item
       (assoc product
         :delivery
         (if delivery? "Delivery" "Shop"))
       :qty qty})))

(defn delete-cart-items [app-atom {:keys [ids confirmed] :as item} qty]
  (let [idset (set ids)
        {:keys [payments payments-pending]} @(totals app-atom)]

    (cond
      (and
        (not confirmed)
        (or (pos? payments) (pos? payments-pending)))
      (grid/confirm-modal app-atom
        {:title "Payments received on sale"
         :text "You've received payments for this sale. Are you sure you want to remove this item instead of completing the sale?"
         :negative true
         :confirm-key :sell/remove-item-confirm
         :confirm-text "Remove Item"
         :cancel-text "Cancel"
         :item item
         :qty qty})

      :else
      (do
        (toaster/open-subtle-progress app-atom)

        #?(:cljs
           (.setTimeout js/window
             (fn []
               (swap! app-atom update-in [:sell :cart :items]
                 #(map (fn [i]
                         (if (contains? idset (:cartitem_id i))
                           (dissoc i :pulse-slat) i)) %)))
             1000))

        (swap! app-atom update-in [:sell :cart :items]
          #(map (fn [i]
                  (if (contains? idset (:cartitem_id i))
                    (assoc i :pulse-slat :remove) i)) %))

        (comms/send :pos/remove-item
          (sell-comms app-atom
            {:item item
             :cartitem_ids (take qty ids)
             :delivery (if (= (:delivery item) "Shop") "Delivery" "Shop")}))))))

(defmethod grid/action :sell/remove-item-confirm [app-atom {:keys [item qty]} _]
  (delete-cart-items app-atom (assoc item :confirmed true) qty))

(defn add-cart-scan [app-atom {:keys [scan]}]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/barcode
    (sell-comms app-atom
      {:barcode scan})))

(rum/defc free-item-modal [app-atom config-atom]
  (let [items (cmn/curact app-atom [:sell :cart :free-item-modal])]
    [[:h3
      {:class (u/bem :heading [:medium-large])}
      "Free items added:"]
     [:p
      {:class (u/bem :paragraph [:large])}
      "Please check stock of the items and mark appropriately"]
     [:ul.tabular-list
      (map
        (fn [i]
          [:li.tabular-list__item i]) items)]]))

(rum/defc free-item-modal-footer [app-atom config-atom]
  (grid/button-row
    {:single-text "Acknowledge"
     :single-style :primary
     :single-no-icon true
     :single-fn
     #(grid/dispatch-modal-action app-atom :sell/clear-free-item-modal)}))

(defmethod grid/modal-config :sell/free-item-modal [app-atom _ _]
  {:body free-item-modal
   :footer free-item-modal-footer
   :modal-type :alert})

(defmethod grid/action :sell/clear-free-item-modal [app-atom _ _]
  (swap! app-atom assoc-in [:sell :cart :free-item-modal] []))

(rum/defc coin-screen [app-atom]
  (sell-screen-wrapper app-atom :sell/scan-coin
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Knife Coin"]
      [:div
       [:i.u-block-center
        {:class
         (u/bem
           :icon
           [:2-1 :barcode-scan :light-force :enormous :block])}]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)})))

(defmethod flow/render-screen :sell/scan-coin [app-atom _]
  (coin-screen app-atom))

(defmethod grid/action :sell/scan-coin [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/scan-coin
    (sell-comms app-atom
      {:barcode scan})))

(defmethod flow/barcode-dispatch-screen :sell/scan-coin [_ app-atom scan]
  (grid/dispatch-action app-atom :sell/scan-coin {:scan scan}))

(defmethod comms/receive :pos/scan-coin [app-atom {:keys [item]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:sell :cart :items]
    (concat
      (get-in @app-atom [:sell :cart :items])
      [item]))
  (grid/dispatch-action app-atom :sell/start-cart {}))

(defmethod comms/receive :pos/check-coin [app-atom {:keys [knife-coin? delivery-coin-added?]}]
  (toaster/close-subtle-progress app-atom)
  (cond
    knife-coin?
    (t/transition-next app-atom :sell/scan-coin)

    delivery-coin-added?
    (grid/dispatch-action app-atom :sell/start-cart {})

    :else
    (grid/dispatch-action app-atom :sell/checkout {})))

(defmethod grid/action :sell/check-coin [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/check-coin
    (sell-comms app-atom
      {:order-uuid (:orderuuid (cmn/curact app-atom :sell))})))

(defmethod comms/receive :pos/add-item [app-atom e]
  #_(js/console.info (str "receiving item from e: " e))
  ;; TODO: Borken paradigm (open + close should be together)
  (toaster/close-subtle-progress app-atom)
  (toaster/close-toast app-atom)
  (grid/close-modal app-atom)

  (when (:warn e)
    (toaster/open-toast app-atom :warning (:warn e) {}))

  (t/transition-next app-atom :sell)
  (when (= (:price (:item e)) 0)
    (swap! app-atom update-in [:sell :cart :free-item-modal]
      #(concat % [(:title (:item e))]))
    (grid/open-modal app-atom :sell/free-item-modal {}))

  (let [ids
        (set
          (or
            (:ids (:item e))
            [(:cartitem_id (:item e))]))]

    #?(:cljs
       (.setTimeout js/window
         (fn []
           (swap! app-atom update-in [:sell :cart :items]
             #(map
                (fn [i]
                  (if (contains? ids (:cartitem_id i))
                    (dissoc i :pulse-slat) i)) %)))
         1000))

    (swap! app-atom update-in [:sell :cart :items]
      (fn [items]
        (vec
          (concat
            (map
              #(-> (:item e)
                 (dissoc :ids)
                 (assoc :cartitem_id %
                   :pulse-slat :add))
              ids)
            items))))))

(declare move-request-confirm-modal)
(defn add-to-cart-scan [app-atom scan]
  (let [movement-request (movement-request scan)]
    (if movement-request
      (move-request-confirm-modal app-atom {:scan scan :movement-request movement-request})
      (add-cart-scan app-atom {:scan scan}))))

(defmethod flow/barcode-dispatch-screen :sell [_ app-atom scan]
  (if (:resumedcart @(cart app-atom))
    (toaster/open-toast app-atom :error "Read only cart - can't scan here." {:closetime 2000})
    (add-to-cart-scan app-atom scan)))

(defmethod comms/receive :pos/update-timeout [app-atom e]
  ;(toaster/open-toast :warning "")
  ;(log (str "Special check timed out."))
  )

(defmethod comms/receive :pos/update-item [app-atom e]
  ;; TODO: Borken paradigm (open + close should be together)
  (toaster/close-subtle-progress app-atom)
  (grid/close-modal app-atom)
  (when (:warn e)
    (toaster/open-toast app-atom :warning (:warn e) {}))

  (let [ids (set (or (:ids e) [(:cartitem_id e)]))]
    (swap! app-atom update-in [:sell :cart :items]
      (fn [items]
        (map
          (fn [i]
            (if (contains? ids (:cartitem_id i))
              (merge i (dissoc e :cartitem_id))
              i))
          items)))))

; region Item Modals

;; ========= Cart Item Menu Modal ===========================
(defmethod grid/action :sell/cartitem-menu-product [app-atom config _]
  (cards/product-info-modal app-atom {:footer-close true} (:item config)))

;; ========= Cart Item Qty Modal ===========================
(rum/defc cartitem-qty-modal-body < rum/reactive [app-atom config-atom]
  (let [item-atom (rum/cursor config-atom :item)
        item (rum/react item-atom)]
    [:div
     (cards/product-infoblock item)
     [:div.u-hr]
     (forms/select "Quantity:" (rum/cursor item-atom :qty)
       (let [packsize (or (:selling_packsize item) 1)]
         (for [x (take 50 (range 0 u/max-value packsize))]
           {:value x :text (str x)}))
       {:small-width true :type :number})]))

(rum/defc cartitem-qty-modal-footer [app-atom config-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn
     #(grid/dispatch-modal-action app-atom :sell/cartitem-qty-modal-cancel)
     :right-text "Save"
     :right-no-icon true
     :right-fn
     #(grid/dispatch-modal-action app-atom :sell/cartitem-qty-modal-save)}))

(defmethod grid/modal-config :sell/cartitem-qty-modal [_ _ _]
  {:body cartitem-qty-modal-body
   :footer cartitem-qty-modal-footer
   :modal-type :alert})

(defmethod grid/action :sell/cartitem-menu-adjustqty [app-atom {:keys [item]} _]
  (grid/open-modal app-atom :sell/cartitem-qty-modal {:item item :olditem item}))

(defmethod grid/action :sell/cartitem-qty-modal-save [app-atom config _]
  (let [{:keys [item olditem]} config
        diff (- (u/parseInt (:qty item)) (:qty olditem))]
    (cond
      (pos? diff)
      (add-cart-item app-atom
        (= "Delivery" (:delivery olditem)) diff item)

      (neg? diff)
      (delete-cart-items app-atom item (- diff)))))

;; ========= Cart Item Price Modal ===========================

(rum/defc cartitem-price-modal-body < rum/reactive [app-atom config-atom]
  ;; TODO: Work with local config-atom state instead of `[:sell :override]`
  ;; needs barcode handling to play with modal state.
  (let [item (cmn/curact config-atom [:item])
        override-atom (rum/cursor-in app-atom [:sell :override])]
    [:div
     (cards/product-infoblock item)
     [:div.u-hr]

     (forms/select "Quantity to adjust:" (rum/cursor override-atom :qty)
       (for [x (range 1 (inc (:qty item)))]
         {:value x :text (str x)})
       {:small-width true :type :number})

     [:div.form-field
      (forms/radio "Percentage Discount" :percentage (rum/cursor override-atom :override-type))]
     [:div.form-field
      (forms/radio "Manually Adjust Price" :randvalue (rum/cursor override-atom :override-type))]

     (if (= (cmn/curact override-atom :override-type) :percentage)
       (forms/select
         "Discount %:"
         (rum/cursor override-atom :discount)
         [{:value 0 :text "Please select"}
          {:value 5 :text "5%"}
          {:value 10 :text "10%"}
          {:value 15 :text "15%"}
          {:value 20 :text "20%"}
          {:value 30 :text "30%"}
          {:value 50 :text "50%"}]
         {:small-width false :type :number})

       (forms/input "Unit Price:" ""
         (rum/cursor override-atom :price)
         {:type :currency}))

     (forms/select
       "Reason:"
       (rum/cursor override-atom :priceoverridereason)
       (concat
         [{:value "" :text "Please select"}]
         (map (fn [v] {:value v :text v})
           (cmn/curact app-atom :priceoverridereasons)))
       {:small-width false})]))

(rum/defc cartitem-price-modal-footer [app-atom config-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn
     #(grid/dispatch-modal-action app-atom :sell/override-price-cancel)
     :right-text "Scan Auth"
     :right-plain true}))

(defmethod grid/modal-config :sell/override-price [_ _ _]
  {:body cartitem-price-modal-body
   :footer cartitem-price-modal-footer})

(defmethod grid/action :sell/cartitem-menu-adjustprice [app-atom {:keys [item]} _]
  (reset! (rum/cursor-in app-atom [:sell :override]) (assoc item :override-type :percentage))
  (grid/open-modal app-atom :sell/override-price {:item item}))

(defmethod grid/action :sell/override-price-scan [app-atom auth _]
  (let [override (get-in @app-atom [:sell :override])
        discount
        (if-not (str/blank? (:discount override))
          (u/parseFloat (:discount override)) 0)
        discount (if (< discount 0) 0 discount)
        price
        (u/floor
          (* (u/parseFloat (:price override))
            (- 1 (/ discount 100))))]
    (cond
      (and (= (:override-type override) :percentage)
        (or (nil? (:discount override))
          (zero? (:discount override))))
      (toaster/open-toast app-atom :error "Select a discount before scanning" {})

      (nil? (u/presence (:priceoverridereason override)))
      (toaster/open-toast app-atom :error "Select a reason before scanning" {})

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :pos/price-override
          (sell-comms app-atom
            {:item override
             :cartitem_ids (take (u/parseInt (or (:qty override) 0)) (:ids override))
             :override
             (assoc auth
               :price price
               :priceoverridereason (:priceoverridereason override)
               :item override)}))))
    false))

(defmethod flow/barcode-dispatch-modal :sell/override-price [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :sell/override-price-scan {:authcode scan}))

;; ========= Cart Item Qty Delivery Modal ===========================
(rum/defc cartitem-qty-delivery-modal-body < rum/reactive [app-atom config-atom]
  (let [item-atom (rum/cursor config-atom :item)
        item (rum/react item-atom)]
    [:div
     (cards/product-infoblock item)
     [:div.u-hr]
     (forms/select
       (if (= (:delivery item) "Delivery")
         "Quantity to take from shop:"
         "Quantity to mark for delivery:")
       (rum/cursor item-atom :qty-delivery-swap)
       (concat
         [{:value nil :text "Please select qty"}]
         (let [packsize (or (:selling_packsize item) 1)]
           (for [x (range packsize (inc (:qty item)) packsize)]
             {:value x :text (str x)})))
       {:small-width false :type :number})]))

(rum/defc cartitem-qty-delivery-modal-footer < rum/reactive [app-atom config-atom]
  (let [item-atom (rum/cursor config-atom :item)
        item (rum/react item-atom)]
    (grid/button-row
      {:left-text "Cancel"
       :left-no-icon true
       :left-fn
       #(grid/dispatch-modal-action app-atom :sell/cartitem-qty-delivery-modal-cancel)
       :right-text
       (if (= (:delivery item) "Delivery") "Mark Shop" "Mark Delivery")
       :right-no-icon true
       :right-fn
       (when (> (get-in item [:qty-delivery-swap]) 0)
         #(grid/dispatch-modal-action app-atom :sell/cartitem-qty-delivery-modal-toggle))})))

(defmethod grid/modal-config :sell/cartitem-qty-delivery-modal [_ _ _]
  {:body cartitem-qty-delivery-modal-body
   :footer cartitem-qty-delivery-modal-footer})

(defmethod grid/action :sell/cartitem-menu-toggledelivery [app-atom config _]
  (let [item (:item config)]
    (if (> (:qty item) 1)
      (grid/open-modal app-atom :sell/cartitem-qty-delivery-modal {:item item})
      (grid/dispatch-action app-atom :sell/cartitem-qty-delivery-modal-toggle {:item item}))))

(defmethod grid/action :sell/cartitem-qty-delivery-modal-toggle [app-atom config _]
  (let [{:keys [ids] :as item} (:item config)
        delivery-atom (rum/cursor-in app-atom [:sell :delivery])
        qty-swap (or (:qty-delivery-swap item) 1)
        ids-swap (take qty-swap ids)]
    (swap! delivery-atom dissoc :store_id :method)
    (comms/send :pos/item-delivery
      (sell-comms app-atom
        {:ids ids-swap
         :item item
         :delivery (if (= (:delivery item) "Shop") "Delivery" "Shop")}))))

;; ===== Remove Item =============
(defmethod grid/action :sell/remove-item [app-atom config _]
  (let [item (:item config)]
    (delete-cart-items app-atom item (:qty item))))

(defmethod comms/receive :pos/remove-item [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (let [ids (set (or (:cartitem_ids e) [(:cartitem_id e)]))]
    (swap! app-atom update-in [:sell :cart :items]
      (fn [items]
        (remove (comp ids :cartitem_id) items)))))

; endregion

; region Main Modals
;; ========= Barcode Modal ===========================
(rum/defc barcode-modal-body < rum/reactive [app-atom config-atom]
  [:div
   [:h3
    {:class (u/bem :heading [:medium-large])}
    "Capture manual barcode"]
   (forms/input "Barcode:" "" (rum/cursor config-atom :scan) {:type :barcode :auto-focus (cmn/auto-focus? app-atom)})])

(rum/defc barcode-modal-footer [app-atom config-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn
     #(grid/dispatch-modal-action app-atom :sell/barcode-modal-cancel)
     :right-text "Capture"
     :right-no-icon true
     :right-fn
     #(grid/dispatch-modal-action app-atom :sell/barcode-modal-capture)}))

(defmethod grid/modal-config :sell/barcode-modal [_ _ _]
  {:body barcode-modal-body
   :footer barcode-modal-footer
   :modal-type :alert})

(defmethod grid/action :sell/barcode-modal-capture [app-atom config _]
  (add-cart-scan app-atom {:scan (:scan config)}))

;; ========= Voucher Modal ===========================
(rum/defc voucher-modal-body < rum/reactive [app-atom config-atom]
  [:div
   [:h3
    {:class (u/bem :heading [:medium-large])}
    "Capture manual voucher"]
   (forms/input "Voucher Code:" "" (rum/cursor config-atom :code) {:type :text :auto-focus (cmn/auto-focus? app-atom)})])

(rum/defc voucher-modal-footer [app-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn
     #(grid/dispatch-modal-action app-atom :sell/voucher-modal-cancel)
     :right-text "Capture"
     :right-no-icon true
     :right-fn
     #(grid/dispatch-modal-action app-atom :sell/voucher-modal-capture)}))

(defmethod grid/modal-config :sell/voucher-modal [_ _ _]
  {:body voucher-modal-body
   :footer voucher-modal-footer
   :modal-type :alert})

(defmethod grid/action :sell/voucher-modal-capture [app-atom config _]
  (add-cart-scan app-atom {:scan (:code config)}))

;; ========= Move Request Modal ===========================
(rum/defc move-request-modal-body [app-atom config-atom]
  ;; TODO: Move the cursor value to localized config-atom - need barcode handling to play well
  ;; with modals first
  [[:h3
    {:class (u/bem :heading [:medium-large])}
    "Create Move Request"]
   [:p.paragraph "Would you like to more this item to the store?"]
   (forms/select "Qty to move:"
     (rum/cursor-in app-atom [:sell :move-request :qty])
     (for [x (range 1 10)]
       {:value x :text (str x) :default 1})
     {:small-width true :type :number})

   [:div.form-field
    (feedback/feedback :barcode-scan "Scan printer to create request" "Locations will print on slips" nil :info :smaller)]])

(rum/defc move-request-modal-footer [app-atom]
  (grid/button-row
    {:single-text "Cancel"
     :single-style :primary
     :single-fn
     #(grid/dispatch-modal-action app-atom :sell/move-request-cancel)}))

(defmethod grid/modal-config :sell/move-request-create [_ _ _]
  {:body move-request-modal-body
   :footer move-request-modal-footer
   :modal-type :alert})

(defn move-request-create-modal [app-atom]
  (grid/open-modal app-atom :sell/move-request-create {}))

(defmethod grid/action :sell/send-movement-req [app-atom config _]
  (let [product (:product config)]
    (swap! app-atom assoc-in [:sell :move-request :item] product)
    (move-request-create-modal app-atom)))

(defmethod flow/barcode-dispatch-modal :sell/move-request-create [_ app-atom scan]
  (let [local-state (swap! app-atom update-in [:sell :move-request :count] #(inc (or % 0)))
        movement-request (get-in local-state [:sell :move-request])]
    (comms/send :pos/create-move-request
      (sell-comms app-atom
        {:printer scan
         :qty (or (get movement-request :qty) 1)
         :item (get movement-request :item)
         :count (get movement-request :count)}))))

(defmethod comms/receive :pos/create-move-request [app-atom e]
  ;; These 'close' methods should only be local to where they get opened...
  (toaster/close-subtle-progress app-atom)
  (grid/close-modal app-atom)

  (cond
    (:warn e) (toaster/open-toast app-atom :warning (:warn e) {})
    (:success e) (toaster/open-toast app-atom :success "Movement Request Created" {})
    :else (toaster/open-toast app-atom :warning "Movement Request Failed" {})))

(defmethod comms/receive :pos/itemselect-move-request [app-atom e]
  ;; TODO: Borken paradigm (open + close should be together)
  (toaster/close-subtle-progress app-atom)
  (grid/close-modal app-atom)
  (cond
    (:warn e) (toaster/open-toast app-atom :warning (:warn e) {})
    :else
    (cards/product-info-modal app-atom {} (:item e)))

  (swap! app-atom assoc-in [:sell :move-request :item] (:item e)))

(defmethod grid/action :sell/move-request-confirm-move [app-atom config _]
  (let [{:keys [move-request]} config]
    (comms/send :pos/confirm-move-request
      (sell-comms app-atom move-request))))

(defmethod comms/receive :pos/confirm-move-request [app-atom e]
  ;; These 'close' methods should only be local to where they get opened...
  (toaster/close-subtle-progress app-atom)
  (grid/close-modal app-atom)

  (cond
    (:warn e) (toaster/open-toast app-atom :warning (:warn e) {})
    (:success e) (toaster/open-toast app-atom :success "Moved" {})
    :else (toaster/open-toast app-atom :warning "Move Fail" {})))

(defmethod grid/action :sell/move-request-confirm-reverse [app-atom config _]
  (let [{:keys [move-request]} config]
    (comms/send :pos/reverse-move-request
      (sell-comms app-atom move-request))))

;; ========= Move Request Confirm Modal ===========================
(rum/defc move-request-confirm-body < rum/reactive [app-atom config-atom]
  (let [movement-request (cmn/curact config-atom [:move-request :movement-request])]
    [[:h3
      {:class (u/bem :heading [:medium-large])}
      "Confirm Move Request"]
     [:ul.list
      [:li "Item to move: " [:b (:barcode movement-request)]]
      [:li "From location: " [:b (:location movement-request)]]]]))

(rum/defc move-request-confirm-footer [app-atom]
  (grid/button-row
    {:left-text "Undo"
     :left-no-icon true
     :left-fn
     #(grid/dispatch-modal-action app-atom :sell/move-request-confirm-reverse)
     :right-text "Move"
     :right-icon :download
     :right-fn
     #(grid/dispatch-modal-action app-atom :sell/move-request-confirm-move)}))

(defmethod grid/modal-config :sell/move-request-confirm [_ _ _]
  {:body move-request-confirm-body
   :footer move-request-confirm-footer
   :modal-type :alert})

(defn move-request-confirm-modal
  [app-atom {:keys [scan movement-request] :as move-request}]
  (grid/open-modal app-atom :sell/move-request-confirm {:move-request move-request}))

;; ========= Open Till Modal ===========================
(rum/defc open-till-body < rum/reactive [app-atom config-atom]
  (let [till-atom (rum/cursor-in app-atom [:sell :open-till])]
    [[:h3
      {:class (u/bem :heading [:medium-large])}
      "Open till"]
     [:p.paragraph
      [:b "Authenticate User: "]
      [:br]
      (if (cmn/curact till-atom [:auth :firstname])
        (str (cmn/curact till-atom [:auth :firstname]) " " (cmn/curact till-atom [:auth :lastname])
          " Authenticated")
        "Scan tag to authenticate")]

     [:p.paragraph.paragraph--flush
      [:b "Select Till: "]
      [:br]
      (if (cmn/curact till-atom :till)
        (str (cmn/curact till-atom [:till]) " Selected")
        "Scan till to open")]]))

(rum/defc open-till-footer [app-atom]
  (grid/button-row
    {:single-text "Cancel"
     :single-style :secondary
     :single-fn
     #(grid/dispatch-modal-action app-atom :sell/open-till-cancel)}))

(defmethod grid/modal-config :sell/open-till [_ _ _]
  {:body open-till-body
   :footer open-till-footer
   :modal-type :alert})

;; ========= Essential goods for delivery Modal ===========================

(defmethod comms/receive :sell/not-permitted [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (grid/open-modal app-atom :sell/not-permitted-confirm
    (select-keys e [:product :essentiallevel])))

(rum/defc not-permitted-delivery-confirm-body < rum/reactive [app-atom config-atom]
  (let [{:keys [product essentiallevel]} (rum/react config-atom)
        {:keys [brand image]} product]

    [:div
     [:div.modal__product-image
      [:img
       {:class (u/bem :image [:full])
        :src (u/cloudinary (:public_id image) {:c "lpad"}) :alt ""}]]

     [:header.modal__product-info
      [:h2.modal__product-title
       [:span.modal__product-brand brand]
       (if brand
         (str/replace (:title product) brand "")
         (:title product))]

      [:ul.modal__product-details
       (cards/product-variation product {:show-packsize true})]]

     [:div.u-hr]

     [:h3 {:class (u/bem :heading [:medium-large])}
      (str "We can’t sell this item during lockdown level " essentiallevel ".")]
     [:span
      "You can mark this item for delivery and we’ll be able to deliver it at a lower lockdown level, once restrictions lift."]]))

(rum/defc not-permitted-delivery-confirm-footer [app-atom config-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn
     #(grid/dispatch-modal-action app-atom :sell/not-permitted-cancel-delivery)
     :right-text "For Delivery"
     :right-no-icon true
     :right-fn
     #(grid/dispatch-modal-action app-atom :sell/not-permitted-confirm-delivery)}))

(defmethod grid/modal-config :sell/not-permitted-confirm [_ _ _]
  {:body not-permitted-delivery-confirm-body
   :footer not-permitted-delivery-confirm-footer})

(defmethod grid/action :sell/not-permitted-confirm-delivery [app-atom config _]
  (grid/dispatch-action app-atom :sell/product-info-deliver {:product (:product config)}))

(defmethod grid/action :sell/not-permitted-cancel-delivery [app-atom config _]
  ;; Do Nothing ?
  )
;; ========= Cart Menu Modal ===========================

(defmethod grid/action :sell/open-barcode-modal [app-atom config _]
  (grid/open-modal app-atom :sell/barcode-modal {:scan ""}))

(defmethod grid/action :sell/open-voucher-modal [app-atom config _]
  (grid/open-modal app-atom :sell/voucher-modal {}))

(defmethod grid/action :sell/open-till-modal [app-atom config _]
  (grid/open-modal app-atom :sell/open-till {}))

(defmethod flow/barcode-dispatch-modal :sell/open-till [_ app-atom scan]
  (let [till (get-in @app-atom [:sell :open-till])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :pos/open-drawer
      (sell-comms app-atom
        {:mobile? true
         :scan scan
         :authcode (:authcode (:auth till))
         :till (:till till)}))))

(defmethod comms/receive :pos/drawer-lookup [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom
    #(->
       %
       (assoc-in [:sell :open-till :auth] (:auth e))
       (assoc-in [:sell :open-till :till] (:till e)))))

(defmethod comms/receive :pos/open-drawer [app-atom e]
  ;; TODO: Borken paradigm (open + close should be together)
  (grid/close-modal app-atom)
  (toaster/open-toast app-atom :success "Till opened" {})
  (swap! app-atom update :sell dissoc :open-till))

(defmethod grid/action :sell/open-discard-confirm-modal [app-atom config _]
  (let [{:keys [payments payments-pending]} @(totals app-atom)]
    (if
      (or (pos? payments) (pos? payments-pending))
      (grid/message-modal app-atom
        {:title "Payments received on sale"
         :text "You've received payments for this sale. You cannot reset a sale with payments against it. Complete the sale or refund the payments."
         :confirm-text "Okay"})
      (grid/confirm-modal app-atom
        {:title "Discard Sale?"
         :text
         [:p {:class (u/bem :paragraph [:flush])}
          "Are you sure you want to discard this sale? All changes will be lost."]
         :confirm-key :sell/reset-cart
         :confirm-text "Discard"
         :icon-left :delete :icon-class :3-2 :negative true
         :cancel-key :sell/cancel-discard-confirm-modal}))))

;; Reset cart
(defmethod grid/action :sell/reset-cart [app-atom config _]
  (toaster/open-toast app-atom :processing "Resetting Sale" {})
  (comms/send :pos/reset-cart
    (sell-comms app-atom {:pos/target-screen :sell :pos/success-message "Sale Reset."})))

; endregion

;; ======== Load online order =============
(defmethod grid/action :sell/load-online-order [app-atom config _]
  (t/transition-next app-atom :sell/online-order-screen))

(rum/defc online-sell-screen-wrapper
  [app-atom {:keys [menu-items]} progress-step body foot-note call-to-action]

  (let [sell-atom (rum/cursor app-atom :sell)
        menu-atom (rum/cursor app-atom :menu)]
    [:div.page-body
     (header/header app-atom "Sell"
       {:search-click #(swap! sell-atom assoc :search {:open true :input ""})})
     (header/menu-overlay menu-atom)
     (header/menu app-atom menu-items)

     (into
       [:div.page-body__main-content
        [:nav.section.button-bar

         (buttons/button
           "Sale Options" #(cart-menu-modal app-atom progress-step)
           {:icon-right :dots-menu-horizontal :muted true :text-default true})]

        [:div.section
         (forms/progress-steps
           (forms/progress-step sell-steps progress-step))]]

       body)

     (into
       [:aside.page-body__footer]
       foot-note)
     call-to-action]))

;; Modal: Staff/Trade Discount Void ========================
(rum/defc modal-void-staff-discount-body < rum/reactive [app-atom config-atom]
  [:div
   [:h3 "Voiding Discount"]
   [:p "Please note that the discount will be voided
        and needs to be re-applied on the payment screen."]])

(rum/defc modal-void-staff-discount-footer [app-atom config-atom]
  (grid/button-row
    {:single-text "OK"
     :single-style :secondary
     :single-fn
     #(grid/dispatch-modal-action app-atom :sell/action-void-staff-discount)}))

(defmethod grid/modal-config :sell/void-staff-discount [_ _ _]
  {:body modal-void-staff-discount-body
   :footer modal-void-staff-discount-footer
   :modal-type :alert
   :requires-action true})

(defmethod grid/action :sell/action-void-staff-discount [app-atom config source]
  (doseq [payment (:payments config)]
    (comms/send :pos/void-payment
      {:session-uuid (:session-uuid @app-atom)
       :orderuuid (get-in @app-atom [:sell :orderuuid])
       :id (:id payment)})))

;; Modal: Staff Discount Void // end =======================

(defn delivery-charge [delivery-config deliveryitems deliverymethod total registry-guest-cart? cart-payments]
  (let [delivery-method (or deliverymethod :door)
        staff-payment (filter (comp #{"Staff" "Trade"} :pmttype) cart-payments)]
    (if
      (and
        (not registry-guest-cart?)
        (or
          (= :postnet delivery-method)
          (= :door delivery-method))
        (not (empty? deliveryitems))
        (or
          (not (empty? staff-payment))
          (< total (* 100 (:threshold delivery-config)))))

      (if (= :postnet delivery-method)
        (:partnercollection delivery-config)
        (:fixed delivery-config))
      0)))

(defn calc-totals [cart-items cart-payments deliverymethod delivery-config]
  (let [[deliveritems shopitems] (u/separate #(= (:delivery %) "Delivery") cart-items)
        subtotal (* 100 (reduce + 0 (map :price cart-items)))
        registry-guest-cart? (first (filter :forregistryitemrefid cart-items))
        delivery (* 100 (delivery-charge delivery-config deliveritems deliverymethod subtotal registry-guest-cart? cart-payments))
        total (+ delivery subtotal)
        calc-payments
        (->>
          cart-payments
          (filter #(#{"Added"} (:status %)))
          (map
            #(cond
               (:percentage %)
               (assoc % :amount (* (/ (:percentage %) 100.0) total))

               :else %)))

        payments
        (reduce + 0
          (map :amount calc-payments))

        change
        (reduce + 0
          (map #(or (:change %) 0) calc-payments))
        discounts (reduce + 0 (map :amount (filter #(#{"Staff" "Trade" "Discount" "Voucher"} (:pmttype %)) cart-payments)))

        ;; TODO: This needs to actually check on vat flag per variation. Some things are non-vat.
        vat
        (+
          (*
            (:vatrate delivery-config)
            (/ delivery 100.0
              (+ 1 (:vatrate delivery-config))))
          (reduce + 0
            (map #(* (:vatrate %) (/ (:price %) (+ 1 (:vatrate %)))) cart-items)))
        vat (int (* vat 100))
        owing (+ (- total payments) change)]
    {:pending-payment-list
     (vec (filter #(= (:status %) "Pending") cart-payments))

     :payments-pending
     (reduce (fnil + 0 0) 0 (map :amount (filter #(= (:status %) "Pending") cart-payments)))

     :voided-payment-list
     (vec (filter #(= (:status %) "Voided") cart-payments))

     :payments-voided
     (reduce (fnil + 0 0) 0 (map :amount (filter #(= (:status %) "Voided") cart-payments)))

     :calc-payments calc-payments
     :subtotal subtotal
     :total total
     :payments payments
     :change change
     :discounts discounts
     :vat vat
     :ex-vat (- total vat)
     :owing owing
     :delivery delivery
     :deliver-count (count deliveritems)
     :item-count (count cart-items)}))

(defn calc-totals-app-state [state]
  (calc-totals
    (get-in state [:sell :cart :items])
    (get-in state [:sell :cart :payments])
    (get-in state [:sell :delivery :method])
    (get-in state [:config :delivery])))

(defonce totals-lifecycle-listener
  (cmn/lifecycle-listener :sell/totals :setup
    (fn [app-atom])))

;; Attach change owed to cash payment line, if applicable
(defn check-change [state]
  (let [{:keys [owing payments] :as totals}
        (calc-totals-app-state state)]
    (if (neg? owing)
      (update-in state [:sell :cart :payments]
        #(loop [[p & ps] %
                acc []]
           (cond
             ;; Couldn't find
             (nil? p) acc

             ;; Found cash line, attach and exit
             (and (= :cash (:type p)))
             (concat acc [(assoc p :change (- owing))] ps)

             ;; Else keep looking
             :else (recur ps (conj acc p)))))
      state)))

(rum/defc order-summary < rum/reactive [totals-atom]
  (let [{:keys [total discounts payments delivery vat ex-vat deliver-count item-count change
                payments-pending]}
        (rum/react totals-atom)
        calc-item
        (fn [label text & [class]]
          [:li.order-calc__item
           [:span.order-calc__item-name label]
           [:span.order-calc__item-value
            (when class {:class class}) text]])]

    [:div.slats--items-to-take
     [:div
      {:class (u/bem :section [:medium])}
      (when-not (zero? item-count)
        [:ul.order-calc
         (calc-item "Total item count: " item-count)
         (calc-item "Items from store: " (- item-count deliver-count))
         (calc-item "Items for delivery: " deliver-count)

         (calc-item "Sub-total:" (str "R" (u/currency-format ex-vat)))

         (when (pos? deliver-count)
           (calc-item "Delivery:" (if (zero? delivery) "Free" (str "R" (u/currency-format delivery)))))

         (calc-item "VAT:" (str "R" (u/currency-format vat)))
         (calc-item "Total:" (str "R" (u/currency-format total)) (u/bem :order-calc__item-value [:total]))

         (when (pos? discounts)
           (calc-item "Vouchers & Discounts:" (str "-R" (u/currency-format discounts))
             :u-text-status-discount))
         (when (pos? payments-pending)
           (calc-item "Payments Pending:" (str "R" (u/currency-format payments-pending))
             :u-text-status-discount))
         (when (pos? (- payments discounts))
           (calc-item "Payments Received:" (str "-R" (u/currency-format (- payments discounts)))
             :u-text-status-discount))
         (when (pos? change)
           (calc-item "Change Given:" (str "R" (u/currency-format change))))])]]))

(rum/defc voucher-code
  [app-atom]
  (let [voucher-atom (rum/cursor-in app-atom [:sell :voucher])]
    (sell-screen-wrapper app-atom :scan
      [[:div.section
        (forms/input "Voucher Code:" "E.g: 12345678901"
          (rum/cursor voucher-atom :code)
          {:required? true :type :number})

        (forms/input "Amount to load:" ""
          (rum/cursor voucher-atom :amount)
          {:required? true :type :currency})]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(grid/dispatch-action app-atom :sell/add-voucher-item {})}))))

(defmethod flow/render-screen :sell/voucher-code [app-atom screen]
  (voucher-code app-atom))

(defmethod grid/action :sell/add-voucher-item [app-atom]
  (let [voucher (get-in @app-atom [:sell :voucher])]
    #_(toaster/open-toast app-atom :processing "Adding voucher" {:closetime 5000})
    (comms/send
      :pos/add-voucher-item
      (sell-comms app-atom
        {:amount (:amount voucher)
         :code (:code voucher)
         :uuid (:uuid voucher)}))))

(defmethod comms/receive :pos/add-voucher-code [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :sell/voucher-code)
  (swap! app-atom assoc-in [:sell :voucher] {:code (:code e) :uuid (u/uuid)}))

(rum/defc search-screen
  [app-atom]
  [:div.page-body
   (header/header app-atom "Sell"
     {:search-click #(swap! app-atom assoc-in [:sell :search] {:open true :input ""})})
   (header/menu-overlay (rum/cursor app-atom :menu))
   (header/menu app-atom (menu/select-menus app-atom))
   (header/search app-atom)

   [:div.page-body__main-content
    (header/search-results app-atom
      {:addcart-fn
       #(grid/dispatch-action app-atom :sell/product-info-addcart {:product (cmn/curval %)})
       :delivery-fn
       #(grid/dispatch-action app-atom :sell/product-info-deliver {:product (cmn/curval %)})
       :notify-fn
       #(cards/notify-me-modal app-atom (cmn/curval %))
       :options-fn
       #(cards/product-info-modal app-atom {} %)})]

   (grid/pos-call-to-action
     {:single-text "Back"
      :single-fn #(t/transition-prev app-atom)
      :single-style :secondary
      :single-icon-left :arrow-left})])

(defmethod grid/action :sell/product-info-addcart [app-atom config _]
  (let [product (:product config)]
    (swap! app-atom assoc-in [:sell :search :view-all] false)
    (add-cart-item app-atom false 1 product)))

(defmethod grid/action :sell/product-info-deliver [app-atom config _]
  (let [product (:product config)]
    (swap! app-atom assoc-in [:sell :search :view-all] false)
    (add-cart-item app-atom true 1 product)))

(defmethod flow/render-screen :search-results [app-atom screen]
  (search-screen app-atom))

(defmethod comms/receive :pos/search [app-atom e]
  (if (= (:term e) (get-in @app-atom [:sell :search :input]))
    (swap! app-atom update-in [:sell :search] assoc :products (:products e) :searching false :clear false)))

(defmethod grid/action :sell/search-results [app-atom config]
  (swap! app-atom assoc-in [:sell :search :open] false)
  (t/transition-next app-atom :search-results))

(defonce search-lifecycle-listener
  (cmn/lifecycle-listener :sell/product-search :setup
    (fn [app-atom]
      (cmn/debounce-in app-atom [:sell :search :input]
        200
        #(when (>= (count %) 2)
           (comms/send :pos/search (sell-comms app-atom {:search %})))

        #(if (< (count %) 2)
           (swap! app-atom update-in [:sell :search] assoc :products nil :searching false :clear true)
           (swap! app-atom update-in [:sell :search] assoc :products nil :searching true :clear false))))))

(rum/defc page-body-footer < rum/reactive [delivery-atom totals-atom addcustomer-fn]
  (when (and (not (cmn/curact delivery-atom :email)) (zero? (cmn/curact totals-atom :item-count)))
    [:p.paragraph.paragraph--flush.u-text-center
     [:a.text-link
      {:on-click addcustomer-fn}
      "Add customer for easier Checkout"]]))

(rum/defc mainsell-buttons < rum/reactive
  [totals-atom checkout-fn]
  (grid/pos-call-to-action
    {:left-text
     (when-not (zero? (cmn/curact totals-atom :owing))
       (str "Owing: R" (u/currency-format (cmn/curact totals-atom :owing))))
     :left-no-icon true
     :right-text "Checkout"
     :right-fn (when-not (zero? (cmn/curact totals-atom :item-count)) checkout-fn)
     :right-style :call-to-action
     :right-no-icon true}))

(defn has-delivery-items? [cart-atom]
  (not (empty? (filter (fn [i] (= (:delivery i) "Delivery")) (:items @cart-atom)))))

(defn trade-approved? [app-atom]
  (or
    (not (get-in @app-atom [:sell :delivery :lookup :trade-user?]))
    (get-in @app-atom [:payments :approved-discount?])))

(defmethod grid/action :sell/checkout [app-atom config]
  (let [cart-atom (cart app-atom)]
    (cond
      (:resumedcart @cart-atom)
      (if (trade-approved? app-atom)
        (do
          (when (get-in @app-atom [:sell :delivery :lookup :trade-user?])
            (comms/send :pos/payment (sell-comms app-atom {:pmttype "Trade"})))
          (t/transition-next app-atom :payment))
        (do
          (swap! app-atom assoc-in [:payments :approve-discount-return] :payment)
          (t/transition-next app-atom :payment/approve-discount)))

      ;:need-summary
      (and
        (not (get-in @app-atom [:sell :delivery :summary-confirmed]))
        (not (empty? (filter (fn [i] (= (:delivery i) "Delivery")) (:items @cart-atom)))))
      (t/transition-next app-atom :delivery/summary)

      ;:need-customer
      (str/blank? (get-in @app-atom [:sell :delivery :email]))
      (t/transition-next app-atom :delivery/customer)

      ;:need-delivery
      (has-delivery-items? cart-atom)
      (t/transition-next app-atom :delivery)

      ;:need-order-note
      (empty? (get-in @app-atom [:sell :cart :note]))
      (t/transition-next app-atom :delivery/cartnote)

      (not (trade-approved? app-atom))
      (do
        (swap! app-atom assoc-in [:payments :approve-discount-return] :payment)
        (t/transition-next app-atom :payment/approve-discount))

      :else
      (do
        (when (get-in @app-atom [:sell :delivery :lookup :trade-user?])
          (comms/send :pos/payment (sell-comms app-atom {:pmttype "Trade"})))
        (t/transition-next app-atom :payment)))))

(rum/defc sell-screen < rum/reactive
  [app-atom]
  (let [totals-atom (totals app-atom)
        cart (cart app-atom)
        addcustomer-fn
        (when-not (cmn/curact cart [:resumedcart])
          #(t/transition-next app-atom :delivery/addcustomer))
        checkout-fn #(grid/dispatch-action app-atom :sell/check-coin {})
        sell-atom (rum/cursor app-atom :sell)
        delivery-atom (rum/cursor sell-atom :delivery)
        discount-payments (->> @app-atom :sell :cart :payments (filter (comp #{"Staff" "Trade"} :pmttype)))]

    ;; TODO: This is misplaced. It should be happening on an action dispatch, not screen render.
    ;; At the moment, it will fire a modal on every redraw..... not ideal.
    ;; Add a listener at transition time
    (when (not (empty? discount-payments))
      (grid/open-modal app-atom :sell/void-staff-discount
        {:payments discount-payments}))

    (sell-screen-wrapper app-atom :scan
      [(add-user-slat delivery-atom totals-atom addcustomer-fn)
       (render-cart app-atom)
       (order-summary totals-atom)]

      [(page-body-footer delivery-atom totals-atom addcustomer-fn)]

      (mainsell-buttons totals-atom checkout-fn))))

(defmethod flow/render-screen :sell [app-atom screen]
  (sell-screen app-atom))

(rum/defc order-note-screen < rum/reactive
  [app-atom]
  (let [note-atom (rum/cursor-in app-atom [:sell :delivery :note])
        note (rum/react note-atom)]
    (sell-screen-wrapper app-atom :delivery/cartnote
      [[:div
        [:form.u-margin-top-24
         [:div.section
          [:h2.heading.heading--standard.u-text-center "Add Notes to Order"]
          (forms/textarea "Order Notes:"
            note-atom
            {:hint "Internal order note (customer won't see)"})]]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn
         #(do
            (send-delivery-details app-atom)
            (cond
              (not (trade-approved? app-atom))
              (do
                (swap! app-atom assoc-in [:payments :approve-discount-return] :payment)
                (t/transition-next app-atom :payment/approve-discount))

              :else
              (do
                (when (get-in @app-atom [:sell :delivery :lookup :trade-user?])
                  (comms/send :pos/payment (sell-comms app-atom {:pmttype "Trade"})))
                (t/transition-next app-atom :payment))))
         :right-text (if (empty? note) "Skip" "Next")}))))

(defmethod flow/render-screen :delivery/cartnote [app-atom screen]
  (order-note-screen app-atom))

(rum/defc finish-screen < rum/reactive
  [app-atom {:keys [menu-items next-fn back-fn]}]
  (let [finish-atom (rum/cursor app-atom :finish)
        menu-atom (rum/cursor app-atom :menu)
        {:keys [checkout-response printed]} (rum/react finish-atom)
        next-enabled?
        (or
          (:timeout checkout-response)
          (:error checkout-response)
          printed
          (cmn/curact finish-atom :no_slip))]
    [:div.page-body
     (header/header app-atom "Sell" {})
     (header/menu-overlay menu-atom)
     (header/menu app-atom menu-items)

     [:div.page-body__main-content
      [:div.section
       (forms/progress-steps
         (forms/progress-step sell-steps :finish))]

      (cond
        (:timeout checkout-response)
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center {:class (u/bem :heading [:large])} [:b "Oops!"]]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-sad])}]
         [:div.u-margin-top-24
          (feedback/feedback :error "We couldn't process the sale"
            "Please scan a printer to submit it again - if a slip prints, then all set.")]]

        (:error checkout-response)
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center {:class (u/bem :heading [:large])} [:b "Please go back and try fix the problem."]]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-sad])}]
         [:div.u-margin-top-24
          (feedback/feedback :error "We couldn't process the sale"
            (str (:error checkout-response)))]]

        printed
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center {:class (u/bem :heading [:large])} [:b "Slip printed."]]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :success :3-3])}]
         [:div.u-margin-top-24
          [:p.u-text-center {:class (u/bem :paragraph [:large :flush])}
           [:b "You're all set."]]
          [:p.u-text-center {:class (u/bem :paragraph [:flush])}
           "Your order number is"
           [:span.u-block (:refno checkout-response)]]]]

        :else
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center {:class (u/bem :heading [:large])} [:b "Thank you!"]]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-happy :3-3])}]
         [:div.u-margin-top-24
          [:p.u-text-center {:class (u/bem :paragraph [:large :flush])}
           [:b "You're all set."]]
          [:p.u-text-center {:class (u/bem :paragraph [:flush])}
           "Your order number is"
           [:span.u-block (:refno checkout-response)]]]
         [:div.u-margin-top-24
          (feedback/action-feedback :warning "Asked customer about slip?" "" (rum/cursor-in finish-atom [:no_slip]) {})]])]

     (when-not
       (or
         (:timeout checkout-response)
         (:error checkout-response)
         printed)
       [:aside.page-body__footer
        [:p.paragraph.paragraph--flush.u-text-center
         "Scan printer to print slip"]])

     (grid/pos-call-to-action
       {:single-text
        (cond
          (:error checkout-response)
          "Back"

          (and (not next-enabled?) (u/has-device-printer?))
          "Use Device Printer"

          :else
          "Done")
        :single-fn
        (cond
          (and next-enabled? (:error checkout-response))
          back-fn

          next-enabled?
          next-fn

          (and (not next-enabled?) (u/has-device-printer?))
          #(t/transition-next app-atom :payment/device-print))
        :single-style (if (:error checkout-response) :secondary :call-to-action)})]))

(rum/defc device-print-screen < rum/reactive
  [app-atom]
  (let [finish-atom (rum/cursor app-atom :finish)
        menu-atom (rum/cursor app-atom :menu)
        {:keys [merchant-printed customer-printed]} (rum/react finish-atom)
        done-enabled? customer-printed]
    [:div.page-body
     (header/header app-atom "Print Copies" {})
     (header/menu-overlay menu-atom)
     (header/menu app-atom (menu/select-menus app-atom))

     [:div.page-body__main-content
      [:div.section
       (forms/progress-steps
         (forms/progress-step sell-steps :finish))]

      [:div {:class (u/bem :section [:medium])}
       [:h2.u-text-center {:class (u/bem :heading [:large])}
        [:b "Print Slips"]]
       [:p.u-text-center {:class (u/bem :paragraph [:flush])}
        "Print customer copy to continue"]

       [:div.u-margin-top-24
        (when merchant-printed
          (feedback/feedback :success "Merchant Copy" "Printed"))
        [:div.u-margin-top-16.u-text-center
         (buttons/button
           (if merchant-printed "Reprint Merchant Copy" "Print Merchant Copy")
           (fn []
             (swap! app-atom assoc-in [:finish :printing-copy] :merchant)
             (finish-print app-atom {:scan "DEVICE-PRINTER" :merchant true}))
           {:icon-right :print :raised true :large true
            :primary (not merchant-printed) :secondary merchant-printed})]]

       [:div.u-margin-top-24
        (when customer-printed
          (feedback/feedback :success "Customer Copy" "Printed"))
        [:div.u-margin-top-16.u-text-center
         (buttons/button
           (if customer-printed "Reprint Customer Copy" "Print Customer Copy")
           (fn []
             (swap! app-atom assoc-in [:finish :printing-copy] :customer)
             (finish-print app-atom {:scan "DEVICE-PRINTER" :merchant false}))
           {:icon-right :print :raised true :large true
            :primary (not customer-printed) :secondary customer-printed})]]]]

     (grid/pos-call-to-action
       {:single-text "Done"
        :single-fn
        (when done-enabled?
          #(grid/dispatch-action app-atom :sell/finish-cart {}))
        :single-style :call-to-action})]))

(defmethod flow/render-screen :payment/finish [app-atom screen]
  (finish-screen app-atom
    {:menu-items (menu/select-menus app-atom)
     :back-fn #(t/transition-prev app-atom)
     :next-fn #(grid/dispatch-action app-atom :sell/finish-cart {})}))

(defmethod flow/render-screen :payment/device-print [app-atom screen]
  (device-print-screen app-atom))

(defmethod flow/barcode-dispatch-screen :payment/device-print [_ app-atom scan]
  (toaster/open-toast app-atom :warning "Use the print buttons on screen" {}))

(defmethod grid/action :sell/finish-cart [app-atom]
  (toaster/open-toast app-atom :processing "Finishing up" {})
  (comms/send :pos/load-cart
    (sell-comms app-atom {:pos/target-screen :main-menu})))

;; Final checkout
(defn checkout-message [sell-state delivery-config]
  (let [{:keys [items payments] :as cart} (get-in sell-state [:cart])
        delivery (get-in sell-state [:delivery])
        lookup (:lookup delivery)
        delivery
        (assoc delivery
          :newslettersubscribe (:newslettersubscribe lookup)
          :promotionsubscribe (:promotionsubscribe lookup)
          :invoice (:invoice lookup))
        totals (calc-totals (:items cart) (:payments cart) (:method delivery) delivery-config)]
    {:no-till true
     :delivery delivery
     :items items
     :totals totals
     :payments
     (map (fn [p] (set/rename-keys p {:id :pmt_id})) payments)}))

(defmethod grid/action :sell/wrapup-cart [app-atom config _]
  (let [app-state @app-atom]
    (toaster/open-toast app-atom :processing "Wrapping things up" {})

    (comms/send :pos/checkout
      (sell-comms app-atom
        (checkout-message (:sell app-state) (get-in app-state [:config :delivery]))))))

(defmethod comms/receive :pos/checkout-complete [app-atom e]
  (toaster/close-toast app-atom)
  (t/transition-next app-atom :payment/finish)

  (swap! app-atom assoc :finish
    {:completed-cart (:sell @app-atom)
     :checkout-response e}))

(defn finish-print [app-atom {:keys [scan merchant]}]
  (let [app-state @app-atom]
    (toaster/open-subtle-progress app-atom)
    (comms/send :pos/print
      (cond->
        (assoc
          (checkout-message
            (get-in app-state [:finish :completed-cart])
            (get-in app-state [:config :delivery]))
          :printername scan
          :session-uuid (:session-uuid app-state)
          :orderuuid (get-in app-state [:finish :completed-cart :orderuuid]))
        (some? merchant) (assoc :merchant merchant)))))

(defmethod flow/barcode-dispatch-screen :payment/finish [_ app-atom scan]
  (finish-print app-atom {:scan scan}))

(defmethod comms/receive :pos/printed-slip [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (let [printing-copy (get-in @app-atom [:finish :printing-copy])]
    (swap! app-atom
      (fn [state]
        (cond-> state
          true
          (-> (assoc-in [:finish :printed] true)
            (assoc-in [:finish :checkout-response] e))

          (= printing-copy :merchant)
          (assoc-in [:finish :merchant-printed] true)

          (= printing-copy :customer)
          (assoc-in [:finish :customer-printed] true)

          true
          (update :finish dissoc :printing-copy))))))